/* ========================= NPM ======================== */
// AOS js
import AOS from "aos";
AOS.init({
    disable: function () {
        let maxWidth = 992;
        return window.innerWidth < maxWidth;
    },
});

// Bootstrap
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";

/* ======================== BASE ======================== */
// Import utilities as needed
import {
    utl_keyboardFocusMode,
    utl_setFooterYear,
    utl_ehElements,
    utl_handleModalClose,
    // utl_toggleCookiesAlert,
    // utl_anchorScrollOffset,
} from "./base/_utils";

// Call utility functions after imported
utl_keyboardFocusMode();
document.querySelector("footer") && utl_setFooterYear();
utl_handleModalClose();
// utl_toggleCookiesAlert();
// utl_anchorScrollOffset();
document.querySelector(".eh-container") && utl_ehElements();

/* ===================== COMPONENTS ===================== */
import navbarInit from "./components/_navigation.js";
navbarInit();

import carouselsInit from "./components/_carousels";
document.querySelector(".carousel") && carouselsInit();

import animateHeaderInit from "./components/_animate-header.js";
document.querySelector(".interior-header-section") && animateHeaderInit();

import animateSubHeadingInit from "./components/_animate-sub-headings.js";
animateSubHeadingInit();

/* ======================== PAGES ======================= */
// Individual page scripts are added in the header of specific page's index file
